import { useQuery } from "@tanstack/react-query";
import { getAllWorkspaces } from "../../../Api/workspace";
import { Workspace } from "../../../Models/workspace";

// GET /v1/workspace/ always pages by 10 (the page_size parameter is
// ignored), so the switcher loads every page.
const SERVER_PAGE_SIZE = 10;
const MAX_PAGES = 50;

const loadAllWorkspaces = async (): Promise<Workspace[]> => {
  const first = await getAllWorkspaces(1, SERVER_PAGE_SIZE);
  const pages = Math.min(
    Math.ceil(first.total / SERVER_PAGE_SIZE),
    MAX_PAGES,
  );
  const rest = await Promise.all(
    Array.from({ length: Math.max(pages - 1, 0) }, (_, index) =>
      getAllWorkspaces(index + 2, SERVER_PAGE_SIZE),
    ),
  );
  const all = [first, ...rest].reduce<Workspace[]>(
    (list, page) => list.concat(page.workspaces),
    [],
  );
  return all.sort((a, b) => a.name.localeCompare(b.name));
};

/** Every workspace (platform admins only), for the workspace switcher. The
 * key starts with "workspaces", so workspace edits refresh it too. */
export const useAllWorkspaces = (enabled: boolean) =>
  useQuery({
    queryKey: ["workspaces", "all"],
    queryFn: loadAllWorkspaces,
    enabled,
    staleTime: 5 * 60 * 1000,
  });
